//Auth token
export const SKIP_AUTHORIZATION_TOKEN_HEADER = "X-WIPO-Skip-Auth-token";
export const AUTH_SKIP_ENDPOINTS: string[] = [
  "data-services",
  "distribution-rules",
];
